exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".train__info[data-v-b226e45c]{flex-wrap:wrap}.train__item--time span[data-v-b226e45c]{width:60px;text-align:center}.repeat[data-v-b226e45c]{box-sizing:border-box;width:100%;position:absolute;top:50%;transform:translateY(-50%);left:0;padding:20px 10px;background-color:#fff;box-shadow:0 2px 10px 0 #666}.cifers[data-v-b226e45c]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-wrap:wrap;align-items:center;justify-content:center;font-size:26px;font-weight:700}.cifers span[data-v-b226e45c]{margin-right:5px}.repeat-btn[data-v-b226e45c]{padding:10px}", ""]);

// exports
